<template lang="pug">
  span(:class="iconClass")
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import { Icons } from '@/icons/icons'

@Component({
  name: 'sageIconErroresTemplate'
})
export default class SageIconErroresTemplateComponent extends Vue {
  iconClass = Icons.WARNING_FULL
}
</script>

<style lang="scss" scoped>
span {
  &:before {
    font-family: $lf-icons-font !important;
    font-size: $icon-size;
    color: $tertiary-saffron-200;
  }
}
</style>
